module.exports = __webpack_public_path__ + "static/media/icon-agenda-online-WHITE.29033d2a.svg";